import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../motion/Reveal";

/** Full-width navy call-to-action band. */
export function CtaBand({
  title = "Let's Build Reliable Government Partnerships",
  text = "Whether you're a government agency seeking dependable procurement support or a supplier interested in partnering with Meridian Vanguard Solutions, we'd welcome the opportunity to connect.",
  buttonLabel = "Contact Us",
  buttonTo = "/contact",
}) {
  return (
    <section data-testid="cta-band" className="bg-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" aria-hidden="true"
        style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)", backgroundSize: "28px 28px" }} />
      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-28">
        <Reveal className="max-w-3xl">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white leading-tight tracking-tight">
            {title}
          </h2>
          <p className="mt-6 text-lg text-white/75 leading-relaxed max-w-2xl">{text}</p>
          <Link
            to={buttonTo}
            data-testid="cta-band-button"
            className="mt-10 group inline-flex items-center gap-3 rounded-xl bg-white text-navy px-8 py-4 font-semibold hover:bg-accent2 hover:text-white transition-colors duration-300"
          >
            {buttonLabel}
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
